module.exports = __webpack_public_path__ + "img/ie.ee674c4.svg";